import React, { useEffect, useState } from 'react'
import Button, { ButtonType } from '../../Button'
import style from './VoteAddEdit.module.scss'
import styles from '@bt-react/styles'
import { OpenQuestionProps, Option, VotesErrorType, VotesMode } from './../types'
import VotesError from '../VotesError'
import AutoHeightTextInput from './AutoHeightTextInput'
import { IconType } from '../../Icon/index';


const MAX_OPTIONS = 5
const emptyOptions = new Array(MAX_OPTIONS).fill({value: ''})

const AddEditVote: React.FC<OpenQuestionProps> = props => {

  const [question, setQuestion] = useState('')
  const [options, setOptions] = useState<Option[]>([])
  const [error, setError] = useState<VotesErrorType | undefined>()
  const [btnDisabled, setBtnDisabled] = useState(false)

  useEffect(() => {
    setQuestion(props.question)
    setOptions(emptyOptions.map(
      (value, i) => props.options[ i.toString() ] ?? value)
    )
  }, [])

  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>, i: number | null) => {
    if (i === null) {
      setQuestion(e.target.value)
      return
    }
    const newOptions = Object.values({...options, [i]:{ value: e.target.value}}) as Option[]
    setOptions(newOptions)
  }

  const removeEmpty = (options: Option[]) =>  options.filter( a => a.value )

  const containsDuplicate = (options: Option[]) => new Set(options.map(a => a.value)).size !== options.length

  const submitVote = () =>{
    setBtnDisabled(true)

    const actualOptions = removeEmpty( options )

    if( actualOptions.length < 2 || !question ){

      setError(VotesErrorType.INSUFFICIENT_DATA)
      setBtnDisabled(false)
    }
    else if( containsDuplicate( actualOptions ) ){
      setError(VotesErrorType.DUPLICATE_ANSWER)
      setBtnDisabled(false)
    }
    else{

      if( props.id ){
        props.editVote({ id: props.id, question, options: actualOptions })
      }
      else {
        props.createVote({ question, options: actualOptions })
      }
    }
  }

  const cancelEdit = () => {

    if( props.id ){

      props.setMode({ mode: VotesMode.DETAILS, selectedVoteId: props.id })
    }
    else{
      props.setMode({ mode: VotesMode.LIST})
    }

  }
  const clearError = () => setError(undefined)

  const indexToAlpha = (i: number) => 'ABCDE'.charAt(i)

  const inputElement = (i: number) => <AutoHeightTextInput
    key={i}
    dataBdd={`answer-input-${i}`}
    name={`answer${indexToAlpha(i)}`}
    value={options[i].value}
    maxLength={136}
    className={ style['openquestion-text-area'] }
    placeholder={`Add answer ${indexToAlpha(i)}${i === 0 ? ' (up to 136 characters)':''}`}
    onChange={handleTextChange}
    index={i}
  />

  return (
    <div className={ style['polls-openquestion-addedit-container'] }
         data-bdd="polls-question-addedit-container" >

      {
        error ? <VotesError
            error={error}
            confirmHandler={clearError}
          />
          :<>
        <div className={ style['openquestion-que-sec'] }>
        <div>
          <strong>Poll question</strong>
        </div>

        <AutoHeightTextInput
          name='question'
          dataBdd='vote-question-input'
          value={question}
          maxLength={ 170 }
          placeholder='Type your question here...'
          onChange={handleTextChange}
          index={null}
        />

      </div>

        <div data-bdd="vote-answer-input-list"
          className={ style['openquestion-answer-sec'] }>
          <div>
            <strong>Answers (up to 5)</strong>
          </div>
          <div className={ style['openquestion-answer-text'] }>
            { options.map((value, i) => inputElement(i)) }
          </div>
        </div>

        <div className={ `${ styles['col-12'] } ${ styles['row'] } ${ style['polls-openquestion-addedit-bottom'] }` }>
          <div className={ `${ style['polls-openquestion-action'] }
            ${ styles['col-6'] } ${ styles['p-0'] } ${ styles['text-left'] }` }>
            <Button type={ ButtonType.buttonType.button }
              onClick={cancelEdit}
              text='Cancel'
              dataBdd='cancel-editing-vote-btn'
              className={ style['openquestion-cancel'] }
              disabled={btnDisabled} />
          </div>
          <div className={ `${ style['polls-openquestion-action'] }
            ${ styles['col-6'] } ${ styles['p-0'] } ${ styles['text-right'] }` }>
            <Button type={ ButtonType.buttonType.button }
              onClick={ submitVote }
              color={IconType.colour.primary}
              text={props.id ? 'Save' : 'Add' }
              dataBdd='add-poll-question-button'
              className={ style['openquestion-add-btn'] }
              disabled={btnDisabled} />
          </div>

        </div>
      </>}

    </div>
  )

}

export default AddEditVote
